"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserTabby = exports.LOG_SEVERITY = void 0;
const index_1 = require("./tabby/index");
const console_adapter_1 = require("./tabby/console_adapter");
const dd_browser_adapter_1 = require("./tabby/dd_browser_adapter");
const null_adapter_1 = require("./tabby/null_adapter");
const defaultLogSeverity = "debug";
const logLevel = index_1.zLogSeverity.safeParse(process.env.LOG_LEVEL ?? defaultLogSeverity);
exports.LOG_SEVERITY = logLevel.success ? logLevel.data : defaultLogSeverity;
const getBrowserTabby = (opts) => {
    return (opts.monitoringEnabled ?
        (0, index_1.buildTabbyInstance)({
            definition: {
                id: "dd_browser",
                adapter: dd_browser_adapter_1.DDBrowserTabbyAdapter,
                dependencies: undefined,
            },
            globalTags: { pid: null, service: "browser", version: opts.version },
            minimumSeverity: index_1.LOG_ALL,
        })
        : opts.consoleLoggingEnabled ?
            (0, index_1.buildTabbyInstance)({
                definition: {
                    id: "console",
                    adapter: console_adapter_1.ConsoleTabbyAdapter,
                    dependencies: undefined,
                },
                globalTags: { pid: null, service: "browser", version: opts.version },
                minimumSeverity: exports.LOG_SEVERITY,
            })
            : (0, index_1.buildTabbyInstance)({
                definition: {
                    id: "null",
                    adapter: null_adapter_1.NullTabbyAdapter,
                    dependencies: undefined,
                },
                globalTags: { pid: null, service: "browser", version: opts.version },
                minimumSeverity: index_1.LOG_NONE,
            }));
};
exports.getBrowserTabby = getBrowserTabby;
//# sourceMappingURL=browser_tabby.js.map